module.exports = __webpack_public_path__ + "static/media/img-manner-papers.351ef650.svg";